import { SmartWeekView } from '@/components/dashboard/SmartWeekView';

export const MobileDashboard = () => {
  return (
    <div className="relative -mt-24 bg-content-warm rounded-t-3xl pt-8 pb-8 px-4 min-h-fit z-20">
      {/* Smart Week View - Intelligent 7-day calendar with integrated today timeline */}
      <SmartWeekView />
    </div>
  );
};